/*!
 *  (c)(r) 2008-2023 IT-Service Robert Frunzke
 */

import { arr_inArray } from './util.js';
import { mj } from './page-mj.js';
import { jQuery } from '../other/jquery-hooked.js';
import { mjt } from './i18ntexts.js';

import { showErrorToast } from './snackbar.js';

import { MDMedia } from './media-data.js';
import { MThumbnails } from './thumbnails.js';
import { MCUnknown } from './media.unknown.js';
import { MViewLinkUtil } from './media-view-link-util.js';

import { setupMediaViewBGCtrlsToolbar } from './media-view-bg-ctrls-toolbar.js';
import { ToolbarSetupUtil } from './media-view-toolbar-util.js';

export let MCImage = function($,mj) {

	const media_class = 1;

	const pixfmts_alpha = {
		'RGBA':1,
		'PALETTE':1,
		'CMYK_ALPHA':1,
		'GRAY_ALPHA':1,
		'Lab_ALPHA':1,
		'MONOCHROME_ALPHA':1,
		'YCbCr_ALPHA':1,
	};


	function ImageDetailPreview( dtinfo, target, xopts, toolbarSetupUtil ) {

		var md_trg = $(target),
			media_id = dtinfo.media_id,
			meta = dtinfo.meta,
			// original size
			md_w = 0, md_h = 0,
			md_size_by_page_and_box = {};

		// backup of last valid source size (before rotation)
		// eslint-disable-next-line no-unused-vars
		var md_bck_w = 0, md_bck_h = 0;

		// rotation in degrees, cw
		var md_rotation = meta[229] ? parseInt(meta[229][0],10) : 0,
			// clipping path index
			md_use_clip_path = meta[234] ? parseInt(meta[234][0],10) : -1,
			// list of available clip_paths
			md_avl_clip_paths = meta[233] && meta[233].length ? meta[233] : [],
			// transparency display flag (0=opaque, 1=transparent)
			md_transparency = meta[235] ? meta[235][0]==1 : false,
			// selected box (empty string or one of MediaBox CropBox BleedBox TrimBox ArtBox)
			md_use_box = meta[238] && meta[238][0] ? meta[238][0] : '',
			// list of available box types
			md_avl_box_types = meta[239] && meta[239].length ? ['MediaBox',...meta[239]] : ['MediaBox'],
			// animation flag
			md_animation = meta[231] && meta[231][0] ? meta[231][0] : '',
			show_animation = md_animation ? false : false, // = !!md_animation

			// current page number
			m_page = 1,
			// available viewport
			md_view_w = Math.max(10,md_trg.width()-10),
			md_view_h = Math.max(10,md_trg.height()-10),
			// device pixel ratio
			//m_dpr = 1.0, m_inv_dpr = 1.0,
			// viewport of image (=actual image display dimensions, dpr applied)
			md_v_w = 0, md_v_h = 0,
			// viewport zoom stack
			md_stack = [],
			// crop settings (current zoom level)
			md_c_x = 0, md_c_y = 0, md_c_w = 0, md_c_h = 0;


		if( md_use_box==='' && md_avl_box_types.length>1 ) md_use_box = md_avl_box_types[0];

		// state for links between multiple views
		var md_view_link = false;
		var md_view_link_id = 0;
		var md_view_link_other_ids = [];
		// eslint-disable-next-line no-unused-vars
		var md_view_linked_from_id = 0;

		if( xopts.view_link_available ) {
			md_view_link_id = (xopts.view_link_group_pfx||'') + MViewLinkUtil.getNextLinkTargetId();
		}

		// NOTE: classes used for "view-link" between previews:
		//   md-view-link-trg-avl
		//   md-view-link-trg-linked
		//   md-view-link-trg-initiated

		// cleanup
		md_trg
			.off('.mjImageDetailPreview .mjIDPViewLink')
			.removeClass('md-view-link-trg-linked md-view-link-trg-initiated')
			.toggleClass('md-view-link-trg-avl',!!xopts.view_link_available);

		// setup html
		md_trg.html( '<div class="md-image"></div>'
					+'<div class="md-view-ctrls" style="display:none;">'
					+  '<div title="'+mjt('md-animation-on')+'" class="md-animation-on"></div>'
					+  '<div title="'+mjt('md-animation-off')+'" class="md-animation-off"></div>'
					+  '<div title="'+mjt('md-zoom-in')+'" class="md-zoom-in"></div>'
					+  '<div title="'+mjt('md-zoom-out')+'" class="md-zoom-out"></div>'
					+  '<div title="'+mjt('md-zoom-100')+'" class="md-zoom-100"></div>'
					+  '<div title="'+mjt('md-rotate-ccw')+'" class="md-rotate-ccw"></div>'
					+  '<div title="'+mjt('md-rotate-cw')+'" class="md-rotate-cw"></div>'
					+  '<div title="'+mjt('md-use-clip_path')+'" class="md-use-clip_path"></div>'
					+  '<div title="'+mjt('md-alpha-on')+'" class="md-alpha-on"></div>'
					+  '<div title="'+mjt('md-alpha-off')+'" class="md-alpha-off"></div>'
					+  '<div title="'+mjt('md-use-box')+'" class="md-use-box"></div>'
					+ ( xopts.view_link_available
						? (	 '<div title="'+mjt('md-view-link-on')+'" class="md-view-link-on"></div>'
							+'<div title="'+mjt('md-view-link-off')+'" class="md-view-link-off"></div>' )
						: '' )
					+ ( xopts.enable_save_view_meta ? '<div title="'+mjt('md-view-save')+'" class="md-view-save"></div>' : '' )
					+'</div>' );

		var md_image = md_trg.children('.md-image');
		var md_structure_overlays = null;
		var md_view_ctrls = md_trg.children('.md-view-ctrls');

		// create widget..
		md_trg.mjMediaPageNavWidget( {
			page_changed: function( evt, data ) {
				// data.page, data.npages, data.npages_actually_unknown
				if( data.page != m_page ) {
					m_page = data.page;
					md_trg.triggerHandler( 'mjsbeforepagechanged', [m_page] );
					update_view(true,true,function() {
						md_trg.triggerHandler( 'mjsafterpagechanged', [m_page] );
					});
				}
			},
		} );

		function _get_preview_suffix() {
			var mc = meta[-1] ? meta[-1][0] : media_class,
				pixfmt = meta[203] ? meta[203][0] : '';
			return (mc==1||mc==4)	// MC_IMAGE or MC_TEXT
				? ( (pixfmt=='' || pixfmt in pixfmts_alpha || (md_use_clip_path!==-1 && md_avl_clip_paths.length>0) ) ? 'png' : 'jpg' )
				: 'png';
		}

		function _get_use_clip_path_idx( use_clip_path_idx ) {
			if( use_clip_path_idx < 0 || use_clip_path_idx >= md_avl_clip_paths.length ) return -1;
			return use_clip_path_idx;
		}

		function _get_clip_path_label( use_clip_path_idx ) {
			if( use_clip_path_idx < 0 || use_clip_path_idx >= md_avl_clip_paths.length ) return mjt('md-use-clip_path-none','!');
			var name = md_avl_clip_paths[use_clip_path_idx];
			return mjt('md-use-clip_path-label','!').replace('%1',name).replace('%2',use_clip_path_idx);
		}

		function _get_use_box_idx( use_box_str, enable_default ) {
			if( enable_default && use_box_str.length===0 ) use_box_str = 'MediaBox';
			return arr_inArray(use_box_str,md_avl_box_types); // note: returns -1, if use_box_str was not found in array...
		}

		function _get_box_type_label( box_type_str ) {
			if( box_type_str.length==0 ) box_type_str = 'MediaBox';
			var labels = {
				MediaBox:	mjt('md-use-box-MediaBox','!'),
				CropBox:	mjt('md-use-box-CropBox','!'),
				BleedBox:	mjt('md-use-box-BleedBox','!'),
				TrimBox:	mjt('md-use-box-TrimBox','!'),
				ArtBox:		mjt('md-use-box-ArtBox','!'),
			};
			return labels.hasOwnProperty(box_type_str) ? labels[box_type_str] : 'UnknownBox';
		}

		function init_src_dimensions_by_page_box_and_rotation( on_done ) {
			var page = m_page,
				use_box = (md_use_box===''&&md_avl_box_types.length>1) ? md_avl_box_types[0] : md_use_box,
				key = page+'@'+use_box;
			//console.log([ media_id, 'init_src_dimensions_by_page_box_and_rotation key='+key, on_done ]);
			function _on_done1(s) {
				var defered_done_list = [on_done];
				if( md_size_by_page_and_box.hasOwnProperty(key) && md_size_by_page_and_box[key][0]==='defered' ) defered_done_list = md_size_by_page_and_box[key][1].slice();
				if( s===null ) s = [0,0];
				else md_size_by_page_and_box[key] = s;
				md_bck_w = md_w = s[0];
				md_bck_h = md_h = s[1];
				if( md_rotation==90 || md_rotation==270 ) {
					// swap width & height
					var t = md_w;
					md_w = md_h;
					md_h = t;
				}

				// console.trace(['init_src_dimensions_by_page_box_and_rotation->_on_done1',defered_done_list,md_trg,target]);

				//console.log([ media_id, 'init_src_dimensions_by_page_box_and_rotation DONE CALLBACKS key='+key, s[0],s[1], defered_done_list.length, defered_done_list ]);
				for( var i=0; i<defered_done_list.length; ++i ) defered_done_list[i]();
			}
			if( md_size_by_page_and_box.hasOwnProperty(key) ) {
				if( md_size_by_page_and_box[key][0]==='defered' ) md_size_by_page_and_box[key][1].push(on_done);
				else _on_done1(md_size_by_page_and_box[key]);
				return;
			} else if( key==='1@' ) {
				var s = [meta[200]?parseInt(meta[200][0],10):0,meta[201]?parseInt(meta[201][0],10):0];
				if( s[0]!==0 && s[1]!==0 ) return _on_done1(s);
			}
			// image dimensions are unknown .. try get dimensions ..
			md_size_by_page_and_box[key] = ['defered',[on_done]];
			if( md_trg.mjMediaPageNavWidget('instance') ) md_trg.mjMediaPageNavWidget('setLoading',true);
			$.postJSON2('json/media/meta-dimensions', 'media_id='+media_id+(dtinfo.is_latest_version?'':'&version='+dtinfo.version)+'&page='+page+'&box='+use_box,
				function _init_src_dimensions_by_page_box_and_rotation_response_success(j) {
					if( j && j.width>0 && j.height>0 ) _on_done1([ parseInt(j.width,10), parseInt(j.height,10) ]);
					else _on_done1(null);
				}, function _init_src_dimensions_by_page_box_and_rotation_response_timeout() {
					_on_done1(null);
				}, function _init_src_dimensions_by_page_box_and_rotation_response_error(jqXHR,textStatus) {
					_on_done1(null);
				}, true );
		}

		function update_view( initial, do_not_trigger_zoom_events, on_update_view_done ) {
			//console.log([ media_id, 'update_view ',initial, do_not_trigger_zoom_events, on_update_view_done, update_view.caller ]);
			/*if( window.devicePixelRatio ) {
				// not used yet ..
				m_dpr = window.devicePixelRatio;
				m_inv_dpr = 1.0 / m_inv_dpr;
			}*/
			// get original image size
			init_src_dimensions_by_page_box_and_rotation( function() {
				// set viewport dimensions
				md_v_w = Math.round(md_view_w);
				md_v_h = Math.round(md_view_h);
				if( initial ) md_stack = [];	//[ [0,0,md_w,md_h] ];
				md_view_ctrls.hide();
				// init animation on/off buttons
				md_view_ctrls
					.children('.md-animation-on').toggle( !!(md_animation && !show_animation) ).end()
					.children('.md-animation-off').toggle( !!(md_animation && show_animation) );
				if( show_animation ) {
					clear_image_overlays();
					md_v_w = Math.round(md_w);
					md_v_h = Math.round(md_h);
					if( false /*!initial*/ || md_v_w > md_view_w || md_v_h > md_view_h ) {
						// fit box
						var image_aspect = md_v_w / md_v_h;
						if( image_aspect > md_view_w/md_view_h ) {
							md_v_w = Math.round(md_view_w);
							md_v_h = Math.round(md_view_w/image_aspect);
						} else {
							md_v_h = Math.round(md_view_h);
							md_v_w = Math.round(md_view_h*image_aspect);
						}
					}
					var vq = !dtinfo.is_latest_version ? '&version='+encodeURIComponent(dtinfo.version) : '';
					var src = 'media/file/get/id/'+media_id
								+ '?modified='+encodeURIComponent(meta[-4]?meta[-4][0]:'')
								//+ '&rotate='+md_rotation
								//+ '&transparency='+(md_transparency?'1':'0')
								//+ ( src_media_class==4 ? '&overprint=1' : '' )
								//+ bq
								+ vq;
					MThumbnails.createResponsiveImgElem2(md_image[0],src,{md_v_w:md_v_w,md_v_h:md_v_h},false,'width="'+md_v_w+'" height="'+md_v_h+'"','lfx');

					md_image.css( {
						marginLeft: Math.round((md_view_w-md_v_w)/2)+'px',
						marginTop: Math.round((md_view_h-md_v_h)/2)+'px',
						width: md_v_w+'px',
						height: md_v_h+'px',
					} );

					MThumbnails.runOnImageLoaded( md_image[0].firstElementChild, function( img ) {
						update_image_overlays();
						md_trg.triggerHandler( 'mjsafterzoomchanged' );
					} );
					md_view_ctrls
						.children('.md-zoom-in,.md-zoom-out,.md-zoom-100,'
								+ '.md-rotate-ccw,.md-rotate-cw,'
								+ '.md-use-clip_path,'
								+ '.md-alpha-on,.md-alpha-off,'
								+ '.md-use-box,.md-view-save,'
								+ '.md-animation-on')
						.hide()
						.end()
						.show();
				} else {
					zoom_cur(true);
				}
				if( on_update_view_done ) on_update_view_done();
			});
		}

		function update_view__but_keep_zoom_stack( initial, do_not_trigger_zoom_events, on_update_view_done, on_update_view_done2 ) {
			//console.log([ media_id, 'update_view__but_keep_zoom_stack ',initial, do_not_trigger_zoom_events, on_update_view_done, on_update_view_done2, update_view__but_keep_zoom_stack.caller ]);
			// get dimensions first (because a defered result will trigger updates, which may change md_stack!)
			init_src_dimensions_by_page_box_and_rotation( function() {
				// save current md_stack
				var saved_zoom_stack = md_stack.slice();
				update_view( initial, do_not_trigger_zoom_events, function() {
					if( on_update_view_done ) on_update_view_done();
					// restore old zoom stack
					var new_zoom_stack = md_stack.slice();
					md_stack = [];
					if( new_zoom_stack.length ) md_stack.push(new_zoom_stack[0].slice());
					else md_stack.push([0,0,md_w,md_h]);
					for( var i=1; i<saved_zoom_stack.length; ++i ) md_stack.push( saved_zoom_stack[i].slice() );
					//console.log( [ saved_zoom_stack, new_zoom_stack, md_stack ] );
					if( md_stack.length>0 ) zoom_to( md_stack[md_stack.length-1].slice(), false, true, do_not_trigger_zoom_events );
					if( on_update_view_done2 ) on_update_view_done2();
				});
			});
		}

		function zoom_cur( do_not_trigger_zoom_events ) {
			//console.log([ media_id, 'zoom_cur ',md_stack.slice(), do_not_trigger_zoom_events, zoom_cur.caller ]);
			zoom_stack(md_stack,md_w,md_h,do_not_trigger_zoom_events);
		}

		function zoom_stack( new_zoom_stack, from_w, from_h, do_not_trigger_zoom_events ) {
			//console.log([ media_id, 'zoom_stack ', new_zoom_stack.slice(), from_w, from_h, do_not_trigger_zoom_events, zoom_stack.caller ]);
			md_stack = new_zoom_stack.slice();
			if( md_stack.length===0 ) {
				zoom_to( [0,0,md_w,md_h], true, false, do_not_trigger_zoom_events );
			} else {
				var scale_x = md_w / from_w,
					scale_y = md_h / from_h;
				for( var i=0; i<md_stack.length; ++i ) {
					var area = md_stack[i];
					md_stack[i] = [ scale_x*area[0], scale_y*area[1], scale_x*area[2], scale_y*area[3] ];
				}
				zoom_to( md_stack[md_stack.length-1].slice(), false, true, do_not_trigger_zoom_events );
			}
		}

		function rotated_area( delta_rotation, area ) {
			if( delta_rotation===0 ) return area;
			var ref_w = md_w,
				ref_h = md_h,
				cc = [ area[0], area[1], area[0]+area[2], area[1]+area[3] ];	// = [llx,lly,urx,ury]
			switch( delta_rotation ) {
			case  90:	cc = [ ref_h-cc[3], cc[0], ref_h-cc[1], cc[2] ]; break;
			case 180:	cc = [ ref_w-cc[2], ref_h-cc[3], ref_w-cc[0], ref_h-cc[1] ]; break;
			case 270:	cc = [ cc[1], ref_w-cc[2], cc[3], ref_w-cc[0] ]; break;
			}
			return [ cc[0], cc[1], cc[2]-cc[0], cc[3]-cc[1] ]; // = [llx,lly,urx-llx,ury-lly]
		}
		function rotate_zoom_stack( new_rotation ) {
			var delta_rotation = new_rotation - md_rotation;
			if( delta_rotation < 0 ) delta_rotation += 360;
			//console.log([ media_id, 'rotate_zoom_stack old='+md_rotation+' new='+new_rotation+' delta='+delta_rotation ]);
			for( var i=0; i<md_stack.length; ++i ) md_stack[i] = rotated_area(delta_rotation,md_stack[i]);
		}

		function jc_sel( c ) {
			if( c.w>1 && c.h>1 ) {
				// compute dimensions in original image
				var cur = md_stack[md_stack.length-1],
					sx = cur[2]/md_v_w,
					sy = cur[3]/md_v_h
					;
				c.x = ( c.x*sx + cur[0] );
				c.y = ( c.y*sy + cur[1] );
				c.w = c.w*sx;
				c.h = c.h*sy;
				// clip area
				if( c.x < 0 ) {
					c.w += c.x;
					c.x = 0;
				}
				if( c.y < 0 ) {
					c.h += c.y;
					c.y = 0;
				}
				if( md_w>0 && c.x + c.w > md_w ) c.w = md_w - c.x;
				if( md_h>0 && c.y + c.h > md_h ) c.h = md_h - c.y;
				if( c.w < 2 || c.h < 2 ) {
					if( c.w < 2 ) c.w = 2;
					if( c.h < 2 ) c.h = 2;
				}
				// zoom
				zoom_to( [c.x,c.y,c.w,c.h], false, false );
			}
		}

		function zoom_in() {
			if( md_stack.length==1 && ( md_w>0 && md_w<md_view_w && md_h>0 && md_h<md_view_h ) ) {
				// special case for small images: first zoom to fit viewport..
				zoom_to( md_stack[0].slice(), false, false );
			} else if( md_stack.length>=1 ) {
				var area = md_stack[md_stack.length-1],
					w = area[2]*0.666666667,
					h = area[3]*0.666666667,
					x = area[0]+0.5*(area[2]-w),
					y = area[1]+0.5*(area[3]-h),
					cur = area,
					sx = cur[2]/md_v_w,
					sy = cur[3]/md_v_h;
				w /= sx;
				h /= sy;
				x = (x-cur[0])/sx;
				y = (y-cur[1])/sy;
				jc_sel( {x:x,y:y,w:w,h:h} );
			}
		}

		function zoom_out() {
			if( md_stack.length >= 2 ) {
				var area = md_stack[md_stack.length-2].slice();
				md_stack.length -= 2;
				zoom_to( area, md_stack.length==0, false );
			} else if( md_stack.length == 1 ) {
				zoom_100();
			}
		}

		function zoom_100() {
			var area = md_stack[0].slice();
			md_stack.length = 0;
			zoom_to( area, true, false );
		}


		function zoom_to( area, initial, replace_on_stack, do_not_trigger_zoom_events ) {
			//console.log( ['zoom_to',md_stack,md_stack.length, area, initial, replace_on_stack, do_not_trigger_zoom_events] );
			//console.log([ media_id, 'zoom_to old=',md_use_box,md_stack.slice(),md_w,md_h,', new=',area.join(','), initial, replace_on_stack, do_not_trigger_zoom_events, zoom_to.caller ]);
			clear_image_overlays();
			// crop range
			md_c_x = Math.round(area[0]);
			md_c_y = Math.round(area[1]);
			md_c_w = Math.round(area[2]);
			md_c_h = Math.round(area[3]);
			// viewport dimensions
			if( md_c_w>0 && md_c_h>0 ) {
				md_v_w = md_c_w;
				md_v_h = md_c_h;
			}
			var md_v_is_scaled_to_fit_view_area = false;
			if( !initial || md_v_w > md_view_w || md_v_h > md_view_h ) {
				// fit box
				var image_aspect = md_v_w / md_v_h;
				if( image_aspect > md_view_w/md_view_h ) {
					md_v_w = (md_view_w);
					md_v_h = (md_view_w/image_aspect);
				} else {
					md_v_w = (md_view_h*image_aspect);
					md_v_h = (md_view_h);
				}
				md_v_is_scaled_to_fit_view_area = true;
			}
			var cq = md_avl_clip_paths.length ? '&clip_path='+encodeURIComponent(md_use_clip_path) : '',
				bq = md_use_box ? '&box='+encodeURIComponent(md_use_box) : '',
				vq = !dtinfo.is_latest_version ? '&version='+encodeURIComponent(dtinfo.version) : '',
				src_media_class = ( dtinfo.meta[-1] && dtinfo.meta[-1][0] ) || 1;

			var md_sv_w,// = Math.min(md_v_w,md_w),
				md_sv_h,// = Math.min(md_v_h,md_h),
				dpr = window.devicePixelRatio || 1.0;

			var b_w = md_v_w,
				b_h = md_v_h;
			if( md_w>0 && md_v_w>=md_w && md_h>0 && md_v_h>=md_h ) {
				b_w = md_w;
				b_h = md_h;
			}
			if( MThumbnails.isRetina() ) {
				md_sv_w = b_w;	//2 * b_w;
				md_sv_h = b_h;	//2 * b_h;
			} else if( dpr>1.001 || dpr<0.99 ) {
				if( md_v_is_scaled_to_fit_view_area ) {
					// use device scaling as-is ...
					md_sv_w = b_w;
					md_sv_h = b_h;
				} else {
					// remove device scaling factor ...
					var dpr_inv = 1.0 / dpr;
					md_sv_w = dpr_inv * (b_w+0.001);
					md_sv_h = dpr_inv * (b_h+0.001);
				}
			} else {
				md_sv_w = b_w;
				md_sv_h = b_h;
			}
			md_v_w = Math.round(md_v_w);
			md_v_h = Math.round(md_v_h);

			var pixfmt = meta[203] ? meta[203][0] : '',
				// may_have_alpha = !!( pixfmt in pixfmts_alpha ) || md_avl_clip_paths.length>0,
				has_alpha = !!( pixfmt in pixfmts_alpha ) || md_use_clip_path!==-1;

			var rimg_scale_dims = {md_v_w:md_v_w,md_v_h:md_v_h,md_sv_w:md_sv_w,md_sv_h:md_sv_h},
				rimg_xattrs = 'width="'+md_v_w+'" height="'+md_v_h+'"';

			var src;
			if( md_c_w>0 && md_c_h>0 ) {
				// image size is known
				src = 'media/file/preview/id/'+media_id+'_'+media_class+'_'+m_page+'_{md_sv_w}_{md_sv_h}_'+md_c_x+'_'+md_c_y+'_'+md_c_w+'_'+md_c_h+'.'+_get_preview_suffix()
						+ '?modified='+encodeURIComponent(meta[-4]?meta[-4][0]:'')
						+ '&rotate='+md_rotation
						+ '&transparency='+(md_transparency?'1':'0')
						+ ( src_media_class==4 ? '&overprint=1' : '' )
						+ cq + bq + vq;
				if( replace_on_stack ) md_stack[md_stack.length-1] = area;
				else md_stack.push(area);
				//console.log([ media_id, 'zoom_to STACK AFTER=',md_stack.slice(), zoom_to.caller ]);
				if( !do_not_trigger_zoom_events ) md_trg.triggerHandler( 'mjsafterzoomto', [m_page,md_rotation,md_use_clip_path,md_use_box,md_stack,md_w,md_h] );
				MThumbnails.createResponsiveImgElem2(md_image[0],src,rimg_scale_dims,false,rimg_xattrs,'lfx');
				md_image.css( {
					marginLeft: Math.round((md_view_w-md_v_w)/2)+'px',
					marginTop: Math.round((md_view_h-md_v_h)/2)+'px',
					width: md_v_w+'px',
					height: md_v_h+'px',
				} );
				MThumbnails.runOnImageLoaded( md_image[0].firstElementChild, function( img ) {
					$(img).Jcrop( {
						onSelect:jc_sel,
						/*boxWidth:md_v_w, boxHeight:md_v_h,*/
						bgColor:'transparent',
						allowMove:false,
						allowResize:false,
						keySupport:false,
					} );
					update_image_overlays();
					md_trg.triggerHandler( 'mjsafterzoomchanged' );
				} );
				md_view_ctrls
					.children('.md-zoom-in').show().end()
					.children('.md-zoom-out,.md-zoom-100').css( 'opacity', md_stack.length<=1 ? '0.3' : '1.0' ).show().end()
					.show();
			} else {
				// image size is unknown
				src = 'media/file/preview/id/'+media_id+'_'+media_class+'_'+m_page+'_{md_sv_w}_{md_sv_h}.'+_get_preview_suffix()
						+ '?modified='+encodeURIComponent(meta[-4]?meta[-4][0]:'')
						+ '&rotate='+md_rotation
						+ '&transparency='+(md_transparency?'1':'0')
						+ ( src_media_class==4 ? '&overprint=1' : '' )
						+ cq + bq + vq;
				MThumbnails.createResponsiveImgElem(md_image[0],src,rimg_scale_dims,false,rimg_xattrs,'lfx');
				MThumbnails.runOnImageLoaded( md_image[0].firstElementChild, function( img ) {
					if( MThumbnails.setIntrinsicImageDimensions(img) ) {

						//console.log([ 'md_v_w='+md_v_w,'md_v_h='+md_v_h,  'img.width='+img.width,'img.height='+img.height,  'md_view_w='+md_view_w,'md_view_h='+md_view_h ]);

						md_v_w = img.width;		//img.naturalWidth || img.width;// || md_v_w;
						md_v_h = img.height;	//img.naturalHeight || img.height;// || md_v_h;
						md_image.attr( { width:md_v_w, height:md_v_h } )
							.css( {
								marginLeft: Math.round((md_view_w-md_v_w)/2)+'px',
								marginTop: Math.round((md_view_h-md_v_h)/2)+'px',
								width: md_v_w+'px',
								height: md_v_h+'px',
							} );
						if( replace_on_stack ) md_stack[md_stack.length-1] = area;
						else md_stack.push(area);
						//console.log([ media_id, 'zoom_to DEFERED STACK AFTER=',md_stack.slice(), zoom_to.caller ]);
						if( !do_not_trigger_zoom_events ) md_trg.triggerHandler( 'mjsafterzoomto', [m_page,md_rotation,md_use_clip_path,md_use_box,md_stack,md_w,md_h] );
						update_image_overlays();
						md_trg.triggerHandler( 'mjsafterzoomchanged' );
					}
				} );
				md_view_ctrls
					.children('.md-zoom-in,.md-zoom-out,.md-zoom-100,.md-rotate-ccw,.md-rotate-cw')
					.hide()
					.end()
					.hide();
			}

			// init animation on/off buttons
			md_view_ctrls
				.children('.md-animation-on').toggle( !!(md_animation && !show_animation) ).end()
				.children('.md-animation-off').toggle( !!(md_animation && show_animation) );

			// init transparency on/off buttons
			md_view_ctrls
				.children('.md-alpha-on').toggle( has_alpha && md_transparency ).end()
				.children('.md-alpha-off').toggle( has_alpha && !md_transparency );

			// init use-clip_path switch
			md_view_ctrls.children('.md-use-clip_path').html(_get_clip_path_label(md_use_clip_path)).toggle( md_avl_clip_paths.length>0 );

			// init use-box switch
			md_view_ctrls.children('.md-use-box').html(_get_box_type_label(md_use_box)).toggle( _get_use_box_idx(md_use_box)!==-1 );

			// init view-link switch
			md_view_ctrls
				.children('.md-view-link-on').toggle( !!md_view_link ).end()
				.children('.md-view-link-off').toggle( !md_view_link );

			// reset loading state
			if( md_trg.mjMediaPageNavWidget('instance') ) md_trg.mjMediaPageNavWidget('setLoading',false);

			// toggle download button for cropped images
			toolbarSetupUtil.withToolbar( function( toolbar ) {
				if( !dtinfo.r_download && toolbar!==null ) {
					$('.mdb-download-i',toolbar).toggle( dtinfo.r_download && md_stack.length>1 && !(md_c_x==0&&md_c_y==0&&md_c_w==md_w&&md_c_h==md_h) );
				}
			} );
		}

		function _toggle_view_save_button() {
			if( xopts.enable_save_view_meta && !show_animation ) {
				var meta_md_rotation = meta[229] ? parseInt(meta[229][0],10) : 0;
				var meta_md_use_clip_path = meta[234] ? parseInt(meta[234][0],10) : -1;
				var meta_md_transparency = meta[235] ? meta[235][0]==1 : false;
				var meta_md_use_box = meta[238] ? meta[238][0] : '';
				md_view_ctrls.children('.md-view-save').toggle( dtinfo.r_edit && ( md_rotation!=meta_md_rotation || md_use_clip_path!=meta_md_use_clip_path || md_transparency!=meta_md_transparency || md_use_box!=meta_md_use_box ) );
			} else {
				md_view_ctrls.children('.md-view-save').hide();
			}
		}

		function set_view_page( page, do_trigger, on_after_change ) {
			//console.log([ media_id, 'set_view_page old='+m_page+', new='+page ]);
			if( page!==m_page ) {
				m_page = page;
				md_trg.triggerHandler( 'mjsbeforepagechanged', [m_page] );
				md_trg.mjMediaPageNavWidget('switchPage',m_page,false,false);
				update_view(true,true,function() {
					if( do_trigger ) md_trg.triggerHandler( 'mjsafterpagechanged', [m_page] );
					if( on_after_change ) on_after_change();
				});
			} else if( on_after_change ) {
				on_after_change();
			}
		}
		function set_view_use_clip_path( val, do_trigger, on_after_change ) {
			if( val===-2 ) {
				// select next in available clip_paths
				var cur_idx = _get_use_clip_path_idx(md_use_clip_path),
					nxt_idx = (cur_idx==md_avl_clip_paths.length-1) ? -1 : ( (cur_idx+md_avl_clip_paths.length+1) % md_avl_clip_paths.length );
				val = _get_use_clip_path_idx(nxt_idx);
			} else {
				// select a specific clip_path
				val = _get_use_clip_path_idx(val);
			}
			if( val!==md_use_clip_path ) {
				md_use_clip_path = val;
				if( do_trigger ) md_trg.triggerHandler( 'mjsbeforeclippathchanged', [md_use_clip_path] );
				update_view__but_keep_zoom_stack(true,true,function() {
					_toggle_view_save_button();
					if( do_trigger ) md_trg.triggerHandler( 'mjsafterclippathchanged', [md_use_clip_path] );
					if( on_after_change ) on_after_change();
				});
			} else if( on_after_change ) {
				on_after_change();
			}
		}
		function set_view_use_box( val, do_trigger, on_after_change ) {
			if( val===1 ) {
				// select next in available boxes
				var cur_idx = _get_use_box_idx(md_use_box,true),
					nxt_idx = (cur_idx+md_avl_box_types.length+val) % md_avl_box_types.length;
				val = md_avl_box_types[nxt_idx];
			} else if( _get_use_box_idx(val)===-1 ) {
				// select a specific box - check if actually available here
				if( on_after_change ) on_after_change();
				return;
			}
			if( val!==md_use_box ) {
				md_use_box = val;
				if( do_trigger ) md_trg.triggerHandler( 'mjsbeforeboxchanged', [md_use_box] );
				update_view(true,true,function() {
					_toggle_view_save_button();
					if( do_trigger ) md_trg.triggerHandler( 'mjsafterboxchanged', [md_use_box] );
					if( on_after_change ) on_after_change();
				});
			} else if( on_after_change ) {
				on_after_change();
			}
		}
		function set_view_rotation( val, is_delta, do_trigger, on_after_change ) {
			var new_rotation = is_delta ? ( (md_rotation+360+val) % 360 ) : val;
			//console.log([ media_id, 'set_view_rotation old='+md_rotation+', new='+new_rotation ]);
			if( new_rotation!==md_rotation ) {
				rotate_zoom_stack(new_rotation);
				md_rotation = new_rotation;
				if( do_trigger ) md_trg.triggerHandler( 'mjsbeforerotationchanged', [md_rotation] );
				update_view(false,true,function() {
					_toggle_view_save_button();
					if( do_trigger ) md_trg.triggerHandler( 'mjsafterrotationchanged', [md_rotation] );
					if( on_after_change ) on_after_change();
				});
			} else if( on_after_change ) {
				on_after_change();
			}
		}

		function set_view_alpha( show_alpha, do_trigger ) {
			md_transparency = !!show_alpha;
			if( do_trigger ) md_trg.triggerHandler( 'mjsbeforealphachanged', [md_transparency] );
			update_view__but_keep_zoom_stack(false,false,function() {
				_toggle_view_save_button();
				if( do_trigger ) md_trg.triggerHandler( 'mjsafteralphachanged', [md_transparency] );
			});
		}


		function setup_view_link_handlers() {
			md_trg
				.on( 'mjsviewlinkotherbecameavailable.mjImageDetailPreview', function( e, vlti, other_elem ) {
					if( arr_inArray(vlti,md_view_link_other_ids)===-1 ) {
						md_view_link_other_ids.push(vlti);
						if( xopts.hasOwnProperty('view_link_auto_on_count') && (md_view_link_other_ids.length+1)==xopts.view_link_auto_on_count ) {
							// establish view link only after ALL required other previews became active ...
							if( md_trg.is('.md-view-link-trg-linked,.md-view-link-trg-initiated') ) {
								// another view link has already established
							} else {
								// but only when no other view link became active earlier
								//console.log([ md_view_link_id,md_view_link_other_ids,   'link_view initiating (X)' ]);
								set_view_link(true,false);
							}
						}
					}
				} )
				.on( 'mjsviewlinkothergotlost.mjImageDetailPreview', function( e, vlti, other_elem ) {
					var i;
					if( (i=arr_inArray(vlti,md_view_link_other_ids))!==-1 ) md_view_link_other_ids.splice(i,1);
				} )
				.on('mjsbeforeviewlinkiset.mjImageDetailPreview',function( e, vlti, state, from_elem ) {

					// console.log({ on:'mjsbeforeviewlinkiset', md_view_link_id, vlti, state, from_elem, from_elem_matches_md_trg: md_trg[0].isSameNode(from_elem),  e });

					md_view_link = state;
					md_view_linked_from_id = state ? vlti : 0;
					setup_view_link__from_linked_initiator(state,from_elem);
				} )
				.on('mjsafterviewlinkiset.mjImageDetailPreview',function _on_mjsafterviewlinkiset_mjImageDetailPreview( e, vlti, state, from_elem ) {

					// console.log({ on:'mjsafterviewlinkiset', md_view_link_id, vlti, state, from_elem, from_elem_matches_md_trg: md_trg[0].isSameNode(from_elem),  e });

					update_view__but_keep_zoom_stack(false,true,function() {
						//console.log([ media_id, 'mjsafterviewlinkiset -> update_view__but_keep_zoom_stack done1' ]);
					},function() {
						//console.log([ media_id, 'mjsafterviewlinkiset -> update_view__but_keep_zoom_stack done2' ]);
					});
				} )
				.on( 'mjsviewlinkset.mjImageDetailPreview', function( e, state ) {
					set_view_link(state,false);
				} )
				.on( 'mjsviewlinkupdate.mjImageDetailPreview', function _on_mjsviewlinkupdate_mjImageDetailPreview( e, sync_state ) {
					md_trg.triggerHandler('mjszoomsyncset',[sync_state]);
					if( sync_state.md_transparency!==md_transparency ) md_trg.triggerHandler('mjsalphaset',[sync_state.md_transparency]);
				} );
		}

		function trigger_view_link_handlers() {
			$(document).triggerHandler('mjsviewlinkbecameavailable',[md_view_link_id,md_trg[0]]);
		}

		function get_sync_state() {
			return {
				m_page: m_page,
				md_use_clip_path: md_use_clip_path,
				md_use_box: md_use_box,
				md_rotation: md_rotation,
				md_transparency: md_transparency,
				md_stack: md_stack.slice(),
				md_w: md_w,
				md_h: md_h,
			};
		}

		function setup_view_link__from_linked_initiator( state, initiator_elem ) {
			var linked_trg = $(initiator_elem),
				initiator_trg = md_trg;

			linked_trg.off('.mjIDPViewLink');
			initiator_trg.off('.mjIDPViewLink');

			if( state ) {
				var _setup_a2b_and_b2a = function( a,b, fun ) {
					fun(a,b);
					fun(b,a);
				};
				_setup_a2b_and_b2a( linked_trg, initiator_trg, function( cv_A, cv_B ) {
					// sync'ed page navigation
					cv_A.on('mjsafterpagechanged.mjIDPViewLink',function(e,page) {
						//console.log([ media_id, 'mjsafterpagechanged.mjIDPViewLink old='+m_page+', new='+page ]);
						var page_B = cv_B.mjMediaPageNavWidget('getNPagesActuallyUnknown')
							? page
							: Math.min(page,cv_B.mjMediaPageNavWidget('getNPages'));
						cv_B.triggerHandler('mjspageset',[page_B]);
					});
					// sync'ed view attributes
					cv_A.on('mjsafterclippathchanged.mjIDPViewLink',function(e,use_clip_path) {
						cv_B.triggerHandler('mjsclippathset',[use_clip_path]);
					});
					cv_A.on('mjsafterboxchanged.mjIDPViewLink',function(e,use_box) {
						cv_B.triggerHandler('mjsboxset',[use_box]);
					});
					cv_A.on('mjsafterrotationchanged.mjIDPViewLink',function(e,rotation) {
						cv_B.triggerHandler('mjsrotationset',[rotation]);
					});
					cv_A.on('mjsafteralphachanged.mjIDPViewLink',function(e,alpha) {
						cv_B.triggerHandler('mjsalphaset',[alpha]);
					});
					// sync'ed zoom
					cv_A.on('mjsafterzoomto.mjIDPViewLink',function(e,from_page,from_rotation,from_use_clip_path,from_use_box,from_zoom_stack,from_w,from_h) {
						var sync_state = {
							m_page: from_page,
							md_use_clip_path: from_use_clip_path,
							md_use_box: from_use_box,
							md_rotation: from_rotation,
							md_transparency: null,
							md_stack: from_zoom_stack.slice(),
							md_w: from_w,
							md_h: from_h,
						};
						cv_B.triggerHandler('mjszoomsyncset',[sync_state]);
					});
				} );

			}
		}


		function set_view_link( state_val, do_trigger ) {
			if( md_view_link==state_val ) return;
			//console.log([ media_id, 'set_view_link old='+md_view_link+', new='+val+', do_trigger='+do_trigger ]);
			var allavl_targets = MViewLinkUtil.getAvailableTargets(),
				linked_targets = allavl_targets.not(md_trg);

			linked_targets.trigger('mjsbeforeviewlinkiset',[md_view_link_id,state_val,md_trg[0]]);

			md_view_link = state_val;
			md_view_linked_from_id = state_val ? md_view_link_id : 0;

			if( state_val ) {
				allavl_targets.removeClass('md-view-link-trg-initiated');
				linked_targets.addClass('md-view-link-trg-linked');
				md_trg.removeClass('md-view-link-trg-linked')
					.addClass('md-view-link-trg-initiated');
			} else {
				allavl_targets.removeClass('md-view-link-trg-linked md-view-link-trg-initiated');
			}
			//console.log([ media_id, 'set_view_link -> update_view__but_keep_zoom_stack BEFORE done1' ]);
			update_view__but_keep_zoom_stack(false,true,function() {
				//console.log([ media_id, 'set_view_link -> update_view__but_keep_zoom_stack done1' ]);
			},function() {
				//console.log([ media_id, 'set_view_link -> update_view__but_keep_zoom_stack done2' ]);
				if( md_view_link ) {
					// push this views state once to all connected views
					linked_targets.triggerHandler('mjsviewlinkupdate',[get_sync_state()]);
				}
				linked_targets.trigger('mjsafterviewlinkiset',[md_view_link_id,md_view_link,md_trg[0]]);
			});
		}

		function set_view_animation( show ) {
			show_animation = !!show;
			// if( show_animation ) {
			// } else {
			// 	// we dont care ...
			// }
			update_view(false,false,function() {
				_toggle_view_save_button();
			});
		}

		function save_view_options() {
			if( !xopts.enable_save_view_meta ) return; // skip
			var data = {
				meta:{
					229: [md_rotation],
					234: [md_use_clip_path],
					235: [md_transparency?'1':'0'],
					238: [md_use_box],
				},
			};
			MDMedia.saveMetaData( [media_id], data, function( updated_data ) {
				var updated_meta = updated_data.meta;
				meta = updated_meta[media_id] || {'-1':[0]};
				md_view_ctrls.children('.md-view-save').hide();
				// re-create thumbnails in all views
				$(document).triggerHandler( 'mjsrecreatethumbnails', [media_id,meta] );
			}, function( error ) {
				// TODO: localize error message:
				showErrorToast( 'Fehler, Darstellungsoptionen konnten nicht gespeichert werden. ' + error );
			} );
		}

		function remove_image_overlays() {
			if( md_structure_overlays!==null ) {
				md_structure_overlays.mjMediaStructureOverlaysWidget('destroy').remove();
				md_structure_overlays = null;
			}
		}
		function setup_image_overlays( media_bbox, ref_bbox, overlays ) {
			remove_image_overlays();
			$('<div class="md-structure-overlays"></div>')
				.css( {
					left: Math.round(5+(md_view_w-md_v_w)/2)+'px',
					top: Math.round(5+(md_view_h-md_v_h)/2)+'px',
					width: Math.round(md_v_w)+'px',
					height: Math.round(md_v_h)+'px',
				} )
				.insertAfter(md_image);
			md_structure_overlays = md_image.next('.md-structure-overlays')
				.mjMediaStructureOverlaysWidget( {
					md_w:md_w, md_h:md_h, md_rotation:md_rotation,
					media_bbox:media_bbox, ref_bbox:ref_bbox,
					md_c_x:md_c_x, md_c_y:md_c_y, md_c_w:md_c_w, md_c_h:md_c_h,
				} )
				.mjMediaStructureOverlaysWidget('setOverlays',overlays);
		}
		function clear_image_overlays() {
			if( md_structure_overlays!==null ) {
				md_structure_overlays.mjMediaStructureOverlaysWidget('clearViewUntilNextUpdate');
			}
		}
		function update_image_overlays() {
			if( md_structure_overlays!==null ) {
				md_structure_overlays
					.css( {
						left: Math.round(5+(md_view_w-md_v_w)/2)+'px',
						top: Math.round(5+(md_view_h-md_v_h)/2)+'px',
						width: Math.round(md_v_w)+'px',
						height: Math.round(md_v_h)+'px',
					} )
					.mjMediaStructureOverlaysWidget('option',{
						md_w:md_w, md_h:md_h, md_rotation:md_rotation,
						md_c_x:md_c_x, md_c_y:md_c_y, md_c_w:md_c_w, md_c_h:md_c_h,
					} );
			}
		}


		// bind close handler
		md_trg.on( 'mjsclose.mjImageDetailPreview', function(e) {
			//console.log(['mjsclose.mjImageDetailPreview',e]);
			md_trg.mjMediaPageNavWidget('destroy');
			md_trg.off('.mjImageDetailPreview .mjIDPViewLink');
			if( xopts.view_link_available ) $(document).triggerHandler('mjsviewlinkgotlost',[md_view_link_id]);
		} );

		// bind resize handler
		md_trg.on( 'mjsresize.mjImageDetailPreview', function(e,w,h) {
			//console.log(['mjsresize.mjImageDetailPreview',e,w,h]);
			md_view_w = Math.max(10,w-10);
			md_view_h = Math.max(10,h-10);
			if( md_w==0 && md_h==0 ) {
				zoom_to( [0,0,md_w,md_h], true, false );
			} else if( md_stack.length==1 && (md_w>0&&md_w<md_view_w&&md_h>0&&md_h<md_view_h) ) {
				zoom_to( md_stack[0].slice(), true, true );
			} else if( md_stack.length>=1 ) {
				zoom_to( md_stack[md_stack.length-1].slice(), false, true );
			} else {
				update_view(false,false);
			}
		});

		// bind show handler
		md_trg.on( 'mjsshow.mjImageDetailPreview', function(e) {
			//console.log(['mjsshow.mjImageDetailPreview',e]);
		});

		// bind menu hover handler
		md_trg.on( 'mjsmenuhover.mjImageDetailPreview', function(e,which,menu,update_menu_cb) {
			if( which=='download' ) {
				if( dtinfo.r_download && md_stack.length>1 && !(md_c_x==0&&md_c_y==0&&md_c_w==md_w&&md_c_h==md_h) ) {
					// enable download of cropped image
					var cq = md_avl_clip_paths.length ? '&clip_path='+encodeURIComponent(md_use_clip_path) : '',
						bq = md_use_box ? '&box='+encodeURIComponent(md_use_box) : '',
						vq = !dtinfo.is_latest_version ? '&version='+encodeURIComponent(dtinfo.version) : '';
					var fn = media_id+'_'+media_class+'_'+m_page+'_'+md_c_x+'_'+md_c_y+'_'+md_c_w+'_'+md_c_h+'.'+_get_preview_suffix();
					var src = 'media/file/crop/id/'+fn
							+ '?rotate='+md_rotation
							+ '&transparency='+(md_transparency?'1':'0')
							+ cq + bq + vq;
					$('<a>',{ href: mj.webroot+src, target: '_parent', download: fn }).text(mjt('mdbt-download-x','!'))
						.insertAfter( menu.children('a:first') );
				}
			}
			update_menu_cb();
		});

		// setup click handlers
		md_view_ctrls
			.children('.md-animation-on').hide().click( function() {
				set_view_animation(true); return false;
			} ).end()
			.children('.md-animation-off').hide().click( function() {
				set_view_animation(false); return false;
			} ).end()
			.children('.md-zoom-in').click(  function() {
				zoom_in();  return false;
			} ).end()
			.children('.md-zoom-out').click( function() {
				zoom_out(); return false;
			} ).end()
			.children('.md-zoom-100').click( function() {
				zoom_100(); return false;
			} ).end()
			.children('.md-rotate-ccw').click( function() {
				set_view_rotation(-90,true,true); return false;
			} ).end()
			.children('.md-rotate-cw').click(  function() {
				set_view_rotation( 90,true,true); return false;
			} ).end()
			.children('.md-use-clip_path').hide().click( function() {
				set_view_use_clip_path(-2,true); return false;
			} ).end()
			.children('.md-use-box').hide().click( function() {
				set_view_use_box(1,true); return false;
			} ).end()
			.children('.md-alpha-on').hide().click( function() {
				set_view_alpha(false,true); return false;
			} ).end()
			.children('.md-alpha-off').hide().click( function() {
				set_view_alpha(true,true); return false;
			} ).end()
			.children('.md-view-link-on').hide().click( function() {
				set_view_link(false,true); return false;
			} ).end()
			.children('.md-view-link-off').hide().click( function() {
				set_view_link(true,true); return false;
			} ).end()
			.children('.md-view-save').hide().click( function() {
				save_view_options(); return false;
			} ).end()
		;

		// setup page-nav widget..
		md_trg.mjMediaPageNavWidget('setupFromFileMetadata',m_page,meta);

		if( md_trg.attr('id')=='md-canvas' ) {
			// bind page navigation key events - but only in detail view (neither in "md-preview", nor anywhere else...)
			md_trg.mjMediaPageNavWidget('setupKeyboardNavigation');
		}

		// bind overlays handlers
		md_trg.on( 'mjsoverlaysremove.mjImageDetailPreview', function( e ) {
			remove_image_overlays();
		});
		md_trg.on( 'mjsoverlayssetup.mjImageDetailPreview', function( e, media_bbox, ref_bbox, overlays ) {
			setup_image_overlays(media_bbox,ref_bbox,overlays);
		});

		// bind page nav sync handler
		md_trg.on( 'mjspageset.mjImageDetailPreview', function( e, page ) {
			set_view_page(page,false);
		});
		md_trg.on( 'mjsclippathset.mjImageDetailPreview', function( e, use_clip_path ) {
			set_view_use_clip_path(use_clip_path,false);
		});
		md_trg.on( 'mjsboxset.mjImageDetailPreview', function( e, use_box ) {
			set_view_use_box(use_box,false);
		});
		md_trg.on( 'mjsrotationset.mjImageDetailPreview', function( e, rotation ) {
			set_view_rotation(rotation,false,false);
		});
		md_trg.on( 'mjsalphaset.mjImageDetailPreview', function( e, alpha ) {
			set_view_alpha(alpha,false);
		});
		// bind zoom sync handler
		md_trg.on( 'mjszoomsyncset.mjImageDetailPreview', function _mjszoomsyncset_mjImageDetailPreview( e, sync_state ) {
			//console.log([ media_id, 'mjszoomsyncset.mjImageDetailPreview old=',get_sync_state(),', new=',sync_state ]);
			function _stage2() {
				set_view_rotation(sync_state.md_rotation,false,false,function() {
					_stage3();
				});
			}
			function _stage3() {

				// TODO: update based on md_use_clip_path !?

				if( sync_state.md_use_box===md_use_box ) {
					init_src_dimensions_by_page_box_and_rotation( function _mjszoomsyncset_mjImageDetailPreview_init_src_dimensions_by_page_box_and_rotation_done() {
						zoom_stack(sync_state.md_stack,sync_state.md_w,sync_state.md_h,true);
					});
				} else {
					set_view_use_box(sync_state.md_use_box,false,function _mjszoomsyncset_mjImageDetailPreview_set_view_use_box_done() {
						zoom_stack(sync_state.md_stack,sync_state.md_w,sync_state.md_h,true);
					});
				}
			}
			set_view_page(sync_state.m_page,false,_stage2);
		});

		if( xopts.view_link_available ) {
			setup_view_link_handlers();
		}

		if( md_animation ) {
			// do not yet auto-start gif animations here
			show_animation = false;
		}

		// init view
		update_view( true, true, function() {
			if( xopts.view_link_available ) trigger_view_link_handlers();
		} );
	}

	return Object.assign( {}, MCUnknown, {

		init: function() {
			// TODO: make this a lazy init ..
			MViewLinkUtil.init();
		},

		createThumbnail: function( media_id, meta, target, iw, ih, version, on_load_cb ) {
			if( MCUnknown.createThumbnailCommon(media_class,media_id,meta,target,iw,ih,version,on_load_cb) ) return;
			var pixfmt = meta[203] ? meta[203][0] : '',
				has_clip_paths = meta[233] && meta[233].length,
				use_clip_path = has_clip_paths && meta[234] ? parseInt(meta[234][0],10) : -1,
				mc = meta[-1] ? meta[-1][0] : media_class,
				sfx = (mc==1||mc==4)	// MC_IMAGE or MC_TEXT
					? ( ( pixfmt=='' || pixfmt in pixfmts_alpha || use_clip_path!==-1 ) ? 'png' : 'jpg' )
					: 'png',
				qry = '?m='+encodeURIComponent(meta[-4]?meta[-4][0]:'')				// add "modified datetime"
						+(version?'&v='+encodeURIComponent(version):'')				// add "version"
						+(meta[229]&&meta[229][0]?'&r='+meta[229][0]:'')			// add "rotation" to prevent caching issues
						+(meta[235]&&meta[235].length?'&t='+meta[235][0]:'')		// add "transparency" to prevent caching issues
						+(has_clip_paths?'&cpi='+use_clip_path:'')					// add "clip_path" to prevent caching issues
						+(meta[238]&&meta[238].length?'&b='+meta[238][0]:''),		// add "use-box" to prevent caching issues
				xattrs = MCUnknown.createThumbnailDimAttrs(meta,iw,ih,false);
			MThumbnails.createResponsiveImgElem(
				target,
				'media/file/thumb/id/'+media_id+'_'+mc+'_{iw}_{ih}.'+sfx+qry,
				{iw:iw,ih:ih},
				true,
				xattrs,
				null,
				on_load_cb
			);
		},

		createPreview: function( dtinfo, target, xopts ) {
			if( dtinfo.meta[10] && dtinfo.meta[10][0] > 0 ) return MCUnknown.createPreview(dtinfo,target,xopts); // custom preview
			let toolbarSetupUtil = new ToolbarSetupUtil();
			setupMediaViewBGCtrlsToolbar( $(target), xopts, (toolbar) => toolbarSetupUtil.onToolbarSetup(toolbar) );
			ImageDetailPreview(dtinfo,target,xopts,toolbarSetupUtil);
		},
	} );
}(jQuery,mj); // namespace MCImage
